export default "__VITE_ASSET__DGN5lNUL__"